import type { TableType } from '../grid/reduxStore/table.types';
import { useBlockContentChangedHandlerWithoutUndoRedo } from './useBlockContentChangedHandlerWithoutUndoRedo';

export function useBlockContentChangedHandler() {
  const blockContentChangedHandler = useBlockContentChangedHandlerWithoutUndoRedo();
  return async (blockId: string, sectionId: string, newHtmlContent: string | TableType) => {
    return await blockContentChangedHandler(blockId, sectionId, newHtmlContent);
  };
}
